import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { ResponseSAS } from '../../Interfaces/ResponseSAS';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ObterMetodosPagamentoService {

  constructor(private http: HttpClient) { };

  obterMetodosPagamentoOS(SessionID, CodigoProduto, CodigoTipoProduto, DataInicioViagem, DataFinalViagem, DiasMultiviagem, QtdePassSenior, CupomDesconto, QtdePassNaoSenior,
    CoberturasAdicionais): Observable<ResponseSAS> {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification": environment[localStorage.ambiente].formasPagamento,
        "Parameters": [
          { "parametername": "SessionID", "parametervalue": SessionID },
          { "parametername": "CodigoProduto", "parametervalue": CodigoProduto },
          { "parametername": "CodigoTipoProduto", "parametervalue": CodigoTipoProduto },
          { "parametername": "DataInicioViagem", "parametervalue": DataInicioViagem },
          { "parametername": "DataFinalViagem", "parametervalue": DataFinalViagem },
          { "parametername": "DiasMultiviagem", "parametervalue": DiasMultiviagem },
          { "parametername": "QtdePassSenior", "parametervalue": QtdePassSenior },
          { "parametername": "CupomDesconto", "parametervalue": CupomDesconto },
          { "parametername": "QtdePassNaoSenior", "parametervalue": QtdePassNaoSenior },
          {
            "parametername": "CoberturasAdicionais", "parameterlist":
              CoberturasAdicionais.map(cob => {
                return {
                  "parametername": "CoberturaAdicional", "parameterlist": [
                    { "parametername": "CodigoCoberturaAdicional", "parametervalue": cob }
                  ]
                }
              })
          }
        ]
      }
    );
  };

  consultaCEP(
    numCep
  ) {
    return this.http.post<ResponseSAS>(
      environment.urlSAS,
      {
        "screenIdentification":
          environment.consultaCEP,
        "Parameters": [
          { "parametername": "NR_CEP_NUM", "parametervalue": numCep }
        ]
      }
    );
  }
  
  emitir(SessionID, Adicionales, Buyer, Days, DeparturePointCode, DestinationCode, DiscountCoupon, EmergencyContact, 
    CCExpirationDate, CCHolder, CCNumber, CCSecurityCode, FormOfPaymentCode, NumberOfPayments,
    ProductCode, ProductTypeCode, PurposeOfTripCode, ValidFrom, ValidTo, Travelers
    ){
      var urlSAS = environment.urlSAS;
    //Preparar Adicionales
    //Adicionales
    var lAdicionales = [];
    Adicionales.forEach(adicional => {
      lAdicionales.push(
        {
          "parametername":"AdditionalCoverage","parameterlist":[
            {"parametername":"Code","parametervalue":adicional.CodigoCoberturaOpcional },
            {"parametername":"CompanyAmount","parametervalue":"0"}
          ]
        }
      );
    });
    //Buyer
    var oBuyer = [
      {"parametername":"IdentityDocuments","parameterlist":[
        {"parametername":"IdentityDocument","parameterlist":[
          {"parametername":"Code","parametervalue":"CPF"},
          {"parametername":"Number","parametervalue":Buyer.CPFNumber}
        ]}
      ]},
      {"parametername":"DateOfBirth","parametervalue":Buyer.DateOfBirth},
      {"parametername":"FirstName","parametervalue":Buyer.FirstName},
      {"parametername":"Gender","parametervalue":Buyer.Gender},
      {"parametername":"LastName","parametervalue":Buyer.LastName},
      {"parametername":"Address","parameterlist":[
        {"parametername":"City","parametervalue":Buyer.Address.City},
        {"parametername":"Neighborhood","parametervalue":Buyer.Address.Neighborhood},
        {"parametername":"StateCode","parametervalue":Buyer.Address.StateCode},
        {"parametername":"Street","parametervalue":Buyer.Address.Street},
        {"parametername":"CountryCode","parametervalue":Buyer.Address.CountryCode},
        {"parametername":"Floor","parametervalue":Buyer.Address.Floor},
        {"parametername":"Number","parametervalue":Buyer.Address.Number},
        {"parametername":"OfficeOrAppartment","parametervalue":Buyer.Address.OfficeOrAppartment},
        {"parametername":"ZipCode","parametervalue":Buyer.Address.ZipCode}
      ]},
      {"parametername":"EmailAddress","parameterlist":[
        {"parametername":"Email","parametervalue":Buyer.EmailAddress}
      ]},
      {"parametername":"IncludeInNewsLetters","parametervalue":"0"},
      {"parametername":"Phones","parameterlist":[
        {"parametername":"Phone","parameterlist":[
          {"parametername":"AreaCode","parametervalue":Buyer.Celular.substring(0,2)},
          {"parametername":"Number","parametervalue":Buyer.Celular.substring(2)},
          {"parametername":"Type","parametervalue":"CELUL"}
        ]}
      ]}
    ];
    var oEmergencyContact = [
      {"parametername":"FirstName","parametervalue":EmergencyContact.FirstName},
      {"parametername":"LastName","parametervalue":EmergencyContact.LastName},
      {"parametername":"EmailAddress","parameterlist": [
        {"parametername":"Email","parametervalue":EmergencyContact.Email}
      ]},
      {"parametername":"Phones","parameterlist":[
        {"parametername":"Phone","parameterlist":[
          {"parametername":"AreaCode","parametervalue":EmergencyContact.Celular.substring(0,2)},
          {"parametername":"Number","parametervalue":EmergencyContact.Celular.substring(2)},
          {"parametername":"Type","parametervalue":"CELUL"}
        ]}
      ]},
      {"parametername":"SendCopyOfVouchers","parametervalue":"0"}
    ];
    var Payment = [
      {"parametername":"CCExpirationDate","parametervalue":CCExpirationDate},
      {"parametername":"CCHolder","parametervalue":CCHolder},
      {"parametername":"CCNumber","parametervalue":CCNumber},
      {"parametername":"CCSecurityCode","parametervalue":CCSecurityCode},
      {"parametername":"FormOfPaymentCode","parametervalue":FormOfPaymentCode},
      {"parametername":"NumberOfPayments","parametervalue":NumberOfPayments}
    ];


    var lAdicionales = [];
    Adicionales.forEach(adicional => {
      lAdicionales.push(
        {
          "parametername":"AdditionalCoverage","parameterlist":[
            {"parametername":"Code","parametervalue":adicional.CodigoCoberturaOpcional },
            {"parametername":"CompanyAmount","parametervalue":"0"}
          ]
        }
      );
    });
    var lTravelers = [];
    Travelers.forEach(traveler => {
      lTravelers.push({"parametername":"TravelerRequest","parameterlist":[
        {"parametername":"CompanyAmount","parametervalue":"0"},
        {"parametername":"DateOfBirth","parametervalue":traveler.DataNacimiento},
        {"parametername":"FirstName","parametervalue":traveler.Nome},
        {"parametername":"Gender","parametervalue":traveler.Sexo},
        {"parametername":"IdentityDocuments","parameterlist":[
          {"parametername":"IdentityDocument","parameterlist":[
            {"parametername":"Code","parametervalue":"CPF"},
            {"parametername":"Number","parametervalue":traveler.CPF}
          ]}
        ]},
        {"parametername":"LastName","parametervalue":traveler.Sobrenombre},
        {"parametername":"PPE","parametervalue":((traveler.PoliticamenteExpuesto) ? "1" : "0")},
        {"parametername":"PPERelationshipCode","parametervalue":""}
      ]})
    });
    var parameters = {
      "screenIdentification":environment[localStorage.ambiente].emitir,
      "Parameters":[
        {"parametername":"SessionID","parametervalue": SessionID},
        {"parametername":"AdditionalCoverage","parameterlist": lAdicionales},
        {"parametername":"Buyer","parameterlist": oBuyer},
        {"parametername":"CompanyAmount","parametervalue":"0"},
        {"parametername":"ConsultantAgency","parametervalue":""},
        {"parametername":"Days","parametervalue": Days},
        {"parametername":"DeparturePointCode","parametervalue": DeparturePointCode},
        {"parametername":"DestinationCode","parametervalue": DestinationCode},
        {"parametername":"DiscountCoupon","parametervalue":DiscountCoupon},
        {"parametername":"EmergencyContact","parameterlist": oEmergencyContact},
        {"parametername":"Notes","parametervalue":""},
        {"parametername":"Payment","parameterlist": Payment},
        {"parametername":"ProductCode","parametervalue":ProductCode},
        {"parametername":"ProductTypeCode","parametervalue":ProductTypeCode},
        {"parametername":"PurposeOfTripCode","parametervalue":PurposeOfTripCode},
        {"parametername":"Travelers","parameterlist": lTravelers},
        {"parametername":"ValidFrom","parametervalue":ValidFrom},
        {"parametername":"ValidTo","parametervalue":ValidTo},
        {"parametername":"VoucherNumber","parametervalue":""}
      ]
    };
    console.log(parameters);
    return this.http.post<ResponseSAS>(
      urlSAS,
      parameters
    );

  }
}
